import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { ApplicationService } from '@app/shared/application/application.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RlaService } from './rla.service';

@Injectable()
export class RlaGuard implements CanActivate {
    constructor(
        private rlaService: RlaService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.rlaService.getRla(this.applicationService.caseId).pipe(map(() => true));
    }
}
